module.exports = __webpack_public_path__ + "static/media/protegosafe_logo_white.a3776430.svg";